const master = {
    bank: {
        icon: null,
        text: 'Bank',
        route: 'admin.setting.bank',
        role: {
            classical: [ 'admin' ],
            paper: [ 'admin' ],
            performance: [ 'admin' ],
            project: [ 'admin'],
        }
    },
    userManagement: {
        icon: null,
        text: 'User Management',
        route: 'admin.setting.user.management',
        role: {
            classical: [ 'admin' ],
            paper: [ 'admin' ],
            performance: [ 'admin' ],
            project: [ 'admin'],
        }
    },
    aspect: {
        icon: null,
        text: 'Aspek Penilaian',
        route: 'admin.setting.aspect',
        role: {
            paper: [ 'admin' ],
            performance: [ 'admin' ],
            project: [ 'admin'],
        }
    },
    perspective: {
        icon: null,
        text: 'Perspektif & Indikator',
        route: 'admin.setting.perspective',
        role: {
            paper: [ 'admin' ],
            performance: [ 'admin' ],
            project: [ 'admin'],
        }
    },
    objective: {
        icon: null,
        text: 'Sasaran Objektif',
        route: 'admin.setting.objective',
        role: {
            paper: [ 'admin' ],
            performance: [ 'admin' ],
            project: [ 'admin'],
        }
    },
}

export default master
